import {Action} from "@ngrx/store";
import {IActivity} from '../../activities/activity';
import {IWebsiteOngoingActivitiesState} from "../reducers/ongoing-activities.reducer";

export const INIT_ONGOING_ACTIVITIES: string = '[ongoing activities] Init Ongoing Activities';

export const UPDATE_ONGOING_ACTIVITY_STATE: string = '[ongoing activities] Update Ongoing Activity State';
export const FINISH_ONGOING_ACTIVITY: string = '[ongoing activities] Finish Ongoing Activity';
export const FINISH_ONGOING_ACTIVITIES_SESSION: string = '[ongoing activities] Finish Ongoing Activities Session';
export const REMOVE_ONGOING_ACTIVITY: string = '[ongoing activities] Remove Ongoing Activity';

export const TOGGLE_ONGOING_ACTIVITIES: string = '[ongoing activities] Toggle Ongoing Activities';

export class InitOngoingActivities implements Action {

  readonly type: string = INIT_ONGOING_ACTIVITIES;
  constructor(public payload: {
    [websiteId: number]: IWebsiteOngoingActivitiesState
  }) {}

}

export class UpdateOngoingActivityState implements Action {

  readonly type: string = UPDATE_ONGOING_ACTIVITY_STATE;
  constructor(public payload: {
    websiteId: number,
    entity: IActivity
  }) {}

}

export class FinishOngoingActivity implements Action {

  readonly type: string = FINISH_ONGOING_ACTIVITY;
  constructor(public payload: {
    websiteId: number,
    entity: IActivity
  }) {}

}

export class FinishOngoingActivitiesSession implements Action {

  readonly type: string = FINISH_ONGOING_ACTIVITIES_SESSION;

}

export class RemoveOngoingActivity implements Action {

  readonly type: string = REMOVE_ONGOING_ACTIVITY;
  constructor(public payload: {
    websiteId: number,
    activityId: string
  }) {}

}

export class ToggleOngoingActivities implements Action {

  readonly type: string = TOGGLE_ONGOING_ACTIVITIES;
  constructor(public payload?: boolean) {}

}

export type OngoingActivitiesAction = InitOngoingActivities | UpdateOngoingActivityState | FinishOngoingActivity | RemoveOngoingActivity | ToggleOngoingActivities;
